var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.393 14.5212C16.2594 14.5079 16.0991 14.5079 15.9522 14.5212C12.7728 14.4143 10.2479 11.8094 10.2479 8.60322C10.2479 5.3303 12.893 2.67188 16.1793 2.67188C19.4522 2.67188 22.1106 5.3303 22.1106 8.60322C22.0973 11.8094 19.5724 14.4143 16.393 14.5212Z",
    stroke: "#171719",
    strokeWidth: 2.00383,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55532 19.7509C6.36177 21.8176 6.36177 25.1856 9.55532 27.2395C13.1843 29.5868 19.136 29.5868 22.765 27.2395C25.9585 25.1728 25.9585 21.8049 22.765 19.7509C19.1492 17.4164 13.1975 17.4164 9.55532 19.7509Z",
    stroke: "#171719",
    strokeWidth: 2.00383,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1602 27C28.0803 26.775 28.9493 26.34 29.6649 25.695C31.6586 23.94 31.6586 21.045 29.6649 19.29C28.9621 18.66 28.1058 18.24 27.1985 18",
    stroke: "#171719",
    strokeWidth: 2.00383,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96997 7.02002C4.85827 7.31876 3.40196 9.26794 3.69916 11.3688C3.99021 13.426 5.86011 14.8714 7.9064 14.6596",
    stroke: "#171719",
    strokeWidth: 2.00383,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3799 7.02002C27.4916 7.31876 28.9479 9.26794 28.6507 11.3688C28.3596 13.426 26.4897 14.8714 24.4435 14.6596",
    stroke: "#171719",
    strokeWidth: 2.00383,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.15991 27C4.23978 26.775 3.37078 26.34 2.65512 25.695C0.661509 23.94 0.661509 21.045 2.65512 19.29C3.358 18.66 4.21422 18.24 5.12157 18",
    stroke: "#171719",
    strokeWidth: 2.00383,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/union.ff2ed3a4.svg";
export { ForwardRef as ReactComponent };